export default __webpack_public_path__ + "static/media/j8.bd2b16a8.png";